import { createApi } from "@dreambigger/shared/src/api/api";
import {
  TokenApi,
  CommunityApi,
  OrgApi,
  CommentApi,
  StoryApi,
  EventApi,
  CollectionApi,
  CloudinaryWeserveApi,
} from "@dreambigger/shared/src/api";
import TokenHelper from "@dreambigger/shared/src/utils/tokenHelper";
import CloudinaryApi from "../cloudinary";

export const api = createApi(
  process.env.NEXT_PUBLIC_API_URL || "https://weserve-test.herokuapp.com",
  process.env.NEXT_PUBLIC_COTRIBUTE_CLIENT_ID ||
    "833e0c7c57a48466eb2ee94db8071d272353ba27e"
);

// Cloudinary Variables

// The name of Cotribute's Cloudinary account.
export const cloudName =
  process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME || "cotribute";

// The API Key for Cotribute's Cloudinary account.
const cloudinaryApiKey =
  process.env.NEXT_PUBLIC_CLOUDINARY_API_KEY || "372936618152671";

export const tokenApi = new TokenApi(api);
export const tokenHelper = new TokenHelper(tokenApi);

// Weserve APIs
export const communityApi = new CommunityApi(api);
export const orgApi = new OrgApi(api);
export const commentApi = new CommentApi(api, tokenHelper);
export const storyApi = new StoryApi(api, tokenHelper);
export const eventApi = new EventApi(api, tokenHelper);
export const collectionApi = new CollectionApi(api, tokenHelper);
export const cloudinaryWeserveApi = new CloudinaryWeserveApi(api, tokenHelper);

// Third Party APIs
export const cloudinaryApi = new CloudinaryApi(cloudName, cloudinaryApiKey);
